<div class="scroll-area">
  <img class="icon-xl" (click)="confirm(false)" [src]="'close.svg' | themeSource">

  @if (data.item.image_url) {
    <div class="img-box img-shimmer">
      <img class="item-img" [lazyLoad]="data.item.image_url" [defaultImage]="placeholderImage()" [errorImage]="placeholderImage()" (click)="openImagePreview()" />
    </div>
  }

  <div class="content">
    <h4 [class.header]="!data.item.image_url">{{ data.item.name }}</h4>
    <p>{{ data.item.description }}</p>

    @if (isViewOnly) {
      @if (displayedItem().price !== 0 || displayedItem().calories) {
        <div class="view-only-price">
          @if (displayedItem().price !== 0) {
            <span>{{ displayedItem().price | currencySpace }}</span>
          }
          @if (displayedItem().calories) {
            <span translate [translateParams]="{ calories: displayedItem().calories }">COMMON.CALORIES</span>
          }
        </div>
      }

      <!-- Options as information only - no radios/checkboxes/steppers, nothing to select. -->
      @for (modifier_group of data.item.modifier_groups; track modifier_group.id) {
        <div class="modifier" [attr.data-testid]="'modifier-group-' + modifier_group.id">
          <div class="line">
            <div class="heading">
              <h4>{{ modifier_group.name }}</h4>
              @if (modifier_group.type === 'min-max') {
                <h4>({{ modifier_group.type_min }}-{{ modifier_group.type_max }})</h4>
              }
            </div>
          </div>
          @for (modifier of availableModifiers(modifier_group); track modifier.id) {
            <div class="line">
              <div class="box">
                <span>{{ modifier.name }}</span>
                @if (modifier.calories) {
                  <span>(<span translate [translateParams]="{ calories: modifier.calories }">COMMON.CALORIES</span>)</span>
                }
              </div>
              @if (modifier.price) {
                <div class="box">
                  <span>+ {{ modifier.price | currencySpace }}</span>
                </div>
              }
            </div>
          }
        </div>
      }
    } @else {
      @for (modifier_group of data.item.modifier_groups; track modifier_group) {
        <div class="modifier" [attr.data-testid]="'modifier-group-' + modifier_group.id">
          <div class="line">
            <div class="heading">
              <h4>{{ modifier_group.name }}</h4>
              @if (modifier_group.type === 'min-max') {
                <h4>({{ modifier_group.type_min }}-{{ modifier_group.type_max }})</h4>
              }
            </div>
            @if (!isGroupValid(modifier_group.id) && submitted()) {
              <span class="required">{{ 'COMMON.REQUIRED' | translate }}</span>
            }
          </div>

          @switch (modifier_group.type) {
            @case ('single') {
              @if (modifier_group.display_type === 'dropdown') {
                <mat-select [formControl]="getControl(modifier_group.id)">
                  <mat-option value="">-</mat-option>
                  @for (modifier of availableModifiers(modifier_group); track modifier) {
                    <mat-option [value]="modifier.id">
                      <div class="line">
                        <div class="box">
                          <span>{{ modifier.name }}</span>
                          @if (modifier.calories) {
                            &nbsp;<span>(<span translate [translateParams]="{ calories: modifier.calories }">COMMON.CALORIES</span>)</span>
                          }
                        </div>
                        <div class="box">
                          @if (modifier.price) {
                            <span>(+ {{ modifier.price | currencySpace }})</span>
                          }
                        </div>
                      </div>
                    </mat-option>
                  }
                </mat-select>
              } @else {
                @for (modifier of availableModifiers(modifier_group); track modifier) {
                  <div class="line">
                    <div class="box">
                      <span>{{ modifier.name }}</span>
                      @if (modifier.calories) {
                        <span>(<span translate [translateParams]="{ calories: modifier.calories }">COMMON.CALORIES</span>)</span>
                      }
                    </div>
                    <div class="box">
                      @if (modifier.price) {
                        <span>+ {{ modifier.price | currencySpace }}</span>
                      }
                      <input class="choice" type="radio" [attr.data-testid]="'modifier-radio-' + modifier.id" [name]="modifier_group.id" [value]="modifier.id" [formControl]="getControl(modifier_group.id)" (click)="deselect(modifier_group.id, modifier.id)">
                    </div>
                  </div>
                }
              }
            }

            @case ('single-compulsory') {
              <div>
                @if (modifier_group.display_type === 'dropdown') {
                  <mat-select [formControl]="getControl(modifier_group.id)" (selectionChange)="onChange(modifier_group)">
                    <mat-option value="">-</mat-option>
                    @for (modifier of availableModifiers(modifier_group); track modifier) {
                      <mat-option [value]="modifier.id">
                        <div class="line">
                          <div class="box">
                            <span>{{ modifier.name }}</span>
                            @if (modifier.calories) {
                              &nbsp;<span>(<span translate [translateParams]="{ calories: modifier.calories }">COMMON.CALORIES</span>)</span>
                            }
                          </div>
                          <div class="box">
                            @if (modifier.price) {
                              <span>(+ {{ modifier.price | currencySpace }})</span>
                            }
                          </div>
                        </div>
                      </mat-option>
                    }
                  </mat-select>
                } @else {
                  @for (modifier of availableModifiers(modifier_group); track modifier) {
                    <div class="line">
                      <div class="box">
                        <span>{{ modifier.name }}</span>
                        @if (modifier.calories) {
                          <span>(<span translate [translateParams]="{ calories: modifier.calories }">COMMON.CALORIES</span>)</span>
                        }
                      </div>
                      <div class="box">
                        @if (modifier.price) {
                          <span>+ {{ modifier.price | currencySpace }}</span>
                        }
                        <input class="choice" type="radio" [attr.data-testid]="'modifier-radio-' + modifier.id" [name]="modifier_group.id" [value]="modifier.id" [formControl]="getControl(modifier_group.id)" (change)="onChange(modifier_group)">
                      </div>
                    </div>
                  }
                }
              </div>
            }

            @case ('multiple') {
              <div>
                @if (modifier_group.type_max) {
                  @for (modifier of availableModifiers(modifier_group); track modifier) {
                    <div class="line">
                      <div class="box">
                        <span>{{ modifier.name }}</span>
                        @if (modifier.calories) {
                          <span>(<span translate [translateParams]="{ calories: modifier.calories }">COMMON.CALORIES</span>)</span>
                        }
                      </div>
                      <div class="box">
                        @if (modifier.price) {
                          <span>+ {{ modifier.price | currencySpace }}</span>
                        }
                        <div class="stepper">
                            @if (getControl(modifier_group.id, modifier.id).value <= 0) {
                              <button type="button" (click)="incrementModifier(modifier_group, modifier.id)">
                                  <mat-icon>add</mat-icon>
                              </button>
                            } @else {
                              <button type="button" (click)="decrementModifier(modifier_group, modifier.id)">
                                  <mat-icon>remove</mat-icon>
                              </button>
                              <span>{{ getControl(modifier_group.id, modifier.id).value }}</span>
                              <button type="button" (click)="incrementModifier(modifier_group, modifier.id)">
                                  <mat-icon>add</mat-icon>
                              </button>
                            }
                        </div>
                      </div>
                    </div>
                    
                  }
                } @else {
                  @for (modifier of availableModifiers(modifier_group); track modifier) {
                    <div class="line">
                      <div class="box">
                        <span>{{ modifier.name }}</span>
                        @if (modifier.calories) {
                          <span>(<span translate [translateParams]="{ calories: modifier.calories }">COMMON.CALORIES</span>)</span>
                        }
                      </div>
                      <div class="box">
                        @if (modifier.price) {
                          <span>+ {{ modifier.price | currencySpace }}</span>
                        }
                        <input class="choice" type="checkbox" [attr.data-testid]="'modifier-checkbox-' + modifier.id" [formControl]="getControl(modifier_group.id, modifier.id)">
                      </div>
                    </div>
                  }
                }
              </div>
            }

            @case ('min-max') {
              @for (modifier of availableModifiers(modifier_group); track modifier) {
                <div class="line">
                  <div class="box">
                    <span>{{ modifier.name }}</span>
                    @if (modifier.calories) {
                      <span>(<span translate [translateParams]="{ calories: modifier.calories }">COMMON.CALORIES</span>)</span>
                    }
                  </div>
                  <div class="box">
                    @if (modifier.price) {
                      <span>+ {{ modifier.price | currencySpace }}</span>
                    }
                    <input class="choice" type="checkbox" [attr.data-testid]="'modifier-checkbox-' + modifier.id" [formControl]="getControl(modifier_group.id, modifier.id)" (change)="check(modifier_group)">
                  </div>
                </div>
              }
            }
          }
        </div>
      }

      <input class="note-input" type="text" data-testid="modifier-note-input" [formControl]="note" [placeholder]="'CART.ADD_NOTE' | translate" [maxlength]="noteMaxLength">
    }

  </div>
</div>

@if (!isViewOnly) {
  <div class="bottom-overlay">
    <div class="stepper">
      <button type="button" (click)="updateQuantity(-1)">
        <mat-icon>remove</mat-icon>
      </button>
      <span>{{ quantity() }}</span>
      <button type="button" (click)="updateQuantity(1)">
        <mat-icon>add</mat-icon>
      </button>
    </div>
    <button class="btn cart-btn" type="button" data-testid="modifier-confirm-button" (click)="confirm(true)">
      {{ (isEditMode ? 'ACTIONS.UPDATE_CART' : 'ACTIONS.ADD_CART') | translate }} {{ total() || 0 | currencySpace }}
    </button>
  </div>
}

<ng-template #imagePreviewTpl>
  <img class="image-preview-close" (click)="closeImagePreview()" [src]="'close.svg' | themeSource" alt="">
  <img class="image-preview-img" [src]="data.item.image_url">
</ng-template>

